import { IFavoriteList } from '../favorites-repository.service/favoritesRepository';
import template from './save-favorite-popover-success.html';

export class SaveFavoritePopoverSuccessController {
    createdList?: IFavoriteList;
}

export const SaveFavoritePopoverSuccessComponent = {
    controller: SaveFavoritePopoverSuccessController,
    template,
    bindings: {
        createdList: '<',
    },
};
